import React from "react";
import { useTranslation } from "react-i18next";
import SFButtonGroup from "../../buttonGroup";
import SFButton from "../../button";
import getStyled from "../../../hooks/getStyled";
import { FONT_FAMILIES } from "../../../theme/styles";

const { styled } = getStyled();

const SFButtonGroupStyled = styled(SFButtonGroup)(({ theme }) => ({
  "& .MuiButton-root": {
    ...FONT_FAMILIES.REGULAR,
  },
}));

const Wrapper = styled("div", { shouldForwardProp: false })(
  ({ theme, hasBlueBorder }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:before, &:after": {
      content: "''",
      borderTop: hasBlueBorder
        ? `1px solid ${theme.palette.blue500.main}`
        : `1px dashed ${theme.palette.grey350.main}`,
      width: "100%",
      height: 0,
    },
  })
);

const CombinatorSelector = (props) => {
  const { t } = useTranslation();
  return (
    <Wrapper
      hasBlueBorder={
        props.value.toLocaleUpperCase() === t("components.queryBuilder.orLabel")
      }
    >
      {props.disableOrCombinator ? (
        <SFButton variant="secondary" disabled>
          {t("components.queryBuilder.andLabel")}
        </SFButton>
      ):(
        <SFButtonGroupStyled
          indicateSelected
          variant="switch"
          color="secondary"
          buttons={[
            {
              label: t("components.queryBuilder.orLabel"),
              onClick: () =>
                props.handleOnChange(t("components.queryBuilder.orLabel")),
              selected:
                props.value.toLocaleUpperCase() ===
                t("components.queryBuilder.orLabel"),
            },
            {
              label: t("components.queryBuilder.andLabel"),
              onClick: () =>
                props.handleOnChange(t("components.queryBuilder.andLabel")),
              selected:
                props.value.toLocaleUpperCase() ===
                t("components.queryBuilder.andLabel"),
            },
          ]}
        />
      )}
    </Wrapper>
  );
};

export default CombinatorSelector;
